import { Injectable, OnDestroy } from '@angular/core';
import { Subject, fromEvent } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class GlobalDynamicStylesService implements OnDestroy {
    private readonly destroy$ = new Subject<void>();

    constructor() {
        this.updateWindowSize(); // Initial update

        fromEvent(window, 'resize')
            .pipe(
                debounceTime(100), // Adjust debounce time as needed (e.g., 100ms)
                takeUntil(this.destroy$)
            )
            .subscribe(() => this.updateWindowSize());
    }

    private updateWindowSize = () => {
        document.documentElement.style.setProperty('--windowInnerHeight', `${window.innerHeight}px`);
        document.documentElement.style.setProperty('--windowInnerWidth', `${window.innerWidth}px`);
    };

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
